import { useState } from 'react'
import type { ClientConfig } from '@/types'

interface ClientFilterProps {
  clients: ClientConfig[]
  selectedIds: Set<string>
  onChange: (ids: Set<string>) => void
}

export function ClientFilter({ clients, selectedIds, onChange }: ClientFilterProps) {
  const [expanded, setExpanded] = useState(false)

  function toggle(boardId: string) {
    const next = new Set(selectedIds)
    if (next.has(boardId)) {
      next.delete(boardId)
    } else {
      next.add(boardId)
    }
    onChange(next)
  }

  function selectAll() {
    onChange(new Set(clients.map((c) => c.boardId)))
  }

  function clearAll() {
    onChange(new Set())
  }

  return (
    <div className="card p-4 sm:p-5">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex flex-wrap items-baseline gap-2">
          <span className="text-sm font-semibold text-brand-black uppercase tracking-wider">
            Clientes exibidos
          </span>
          <span className="text-brand-taupe text-xs">
            {selectedIds.size} de {clients.length} selecionados
          </span>
        </div>

        <div className="flex items-center gap-2">
          {expanded && (
            <>
              <button onClick={selectAll} className="btn-ghost text-xs px-3 py-1.5">
                Selecionar todos
              </button>
              <button onClick={clearAll} className="btn-ghost text-xs px-3 py-1.5">
                Limpar seleção
              </button>
            </>
          )}
          <button
            onClick={() => setExpanded((prev) => !prev)}
            className="btn-ghost text-xs px-3 py-1.5"
          >
            {expanded ? 'Fechar' : 'Editar seleção'}
          </button>
        </div>
      </div>

      {expanded && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-3 mt-4 pt-4 border-t border-brand-beige">
          {clients.map((client) => (
            <label
              key={client.boardId}
              className="flex items-center gap-2 text-sm text-brand-black cursor-pointer select-none"
            >
              <input
                type="checkbox"
                checked={selectedIds.has(client.boardId)}
                onChange={() => toggle(client.boardId)}
                className="w-4 h-4 rounded border-brand-beige text-brand-black
                           focus:ring-2 focus:ring-brand-taupe cursor-pointer accent-brand-black"
              />
              {client.name}
            </label>
          ))}
        </div>
      )}
    </div>
  )
}
